import script from "./HelpPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpPanel.vue?vue&type=script&setup=true&lang=js"

import "./HelpPanel.vue?vue&type=style&index=0&id=51ab5fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ab5fba"]])

export default __exports__